import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CBCBDB",
      "fill-opacity": ".9",
      d: "M8.225 2.225a.6.6 0 0 1 .21.012A5.78 5.78 0 0 1 13.78 8q-.001.538-.1 1.063a2 2 0 0 0-.26-.047l-.179-.01h-.825a4.5 4.5 0 0 0-.02-2.1H10.33q.058.544.059 1.094-.002.513-.053 1.02a1.75 1.75 0 0 0-.906 3.076l-.41.409a1.75 1.75 0 0 0-.513 1.25l-.071.008a.6.6 0 0 1-.211.012q-.112.005-.225.006-.112 0-.226-.006a.6.6 0 0 1-.21-.012 5.78 5.78 0 0 1-3.652-1.675 5.782 5.782 0 0 1 3.652-9.85.6.6 0 0 1 .21-.013q.112-.005.226-.006.113 0 .225.006m-1.056 8.119c.19.717.47 1.41.831 2.064.361-.654.64-1.347.831-2.064zm-3.047 0a4.53 4.53 0 0 0 2.42 1.945 10.4 10.4 0 0 1-.66-1.945zm-.518-3.438a4.5 4.5 0 0 0-.001 2.188H5.67a10.4 10.4 0 0 1 0-2.188zm3.326 0A9 9 0 0 0 6.86 8q.002.55.069 1.094H9.07Q9.138 8.55 9.14 8q-.001-.55-.068-1.094zm-.388-3.195a4.53 4.53 0 0 0-2.42 1.945h1.76c.155-.668.376-1.32.66-1.945M8 3.59a9 9 0 0 0-.831 2.065H8.83A9 9 0 0 0 8 3.591m1.457.12q.428.941.661 1.945h1.76a4.53 4.53 0 0 0-2.421-1.945",
      style: {"fill":"color(display-p3 .7976 .7976 .8582)","fill-opacity":".9"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.222",
      d: "m10.257 13.742 2.986-2.986m0 0h-2.688m2.688 0v2.688",
      style: {"stroke":"#fff","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }